/**
 * Deutsche Texte (Entscheidung „Zielgruppe“: weitere Sprachen später, i18n-fähig ab Tag 1). Neue Texte immer
 * hier anlegen und über `t()` verwenden – nie fest in Komponenten schreiben. Du-Form in der Oberfläche.
 */
export const de = {
  "admin.instance": "Instanz",
  "admin.general": "Allgemein",
  "admin.appearance": "Gestaltung",
  "admin.mail": "E-Mail · SMTP",
  "admin.users": "Personen",
  "admin.teams": "Teams",
  "admin.projects": "Projekte & Boards",
  "admin.access": "Notfallzugriff",
  "admin.name": "Name",
  "admin.email": "E-Mail-Adresse",
  "admin.logo": "Logo",
  "admin.color": "Akzentfarbe",
  "admin.inheritColor": "Übernehmen",
  "admin.inherit": "Ohne eigene Farbe oder eigenes Logo gilt die Gestaltung der übergeordneten Ebene. Ein Projekt kann zusätzlich ein Gestaltungsteam wählen.",
  "admin.designTeam": "Gestaltung von Team übernehmen",
  "admin.designTeamHint": "Bei mehreren Teams bestimmt diese Auswahl eindeutig, welche Gestaltung gilt. Eigene Projektwerte haben Vorrang.",
  "admin.workspaceDefault": "Arbeitsgruppe verwenden",
  "admin.preview": "Vorschau der Gestaltung",
  "admin.saved": "Gespeichert.",
  "admin.workspacesHint": "Hier verwaltest du die Arbeitsgruppen, in denen du Mitglied bist. Projekte öffnest du weiterhin über die Lobby.",
  "admin.structureHint": "Instanzweite Einstellungen an einem Ort. Teams, Projektgestaltung und Mitgliedschaften findest du in der jeweiligen Arbeitsgruppe.",
  "admin.sections": "Einstellungsbereiche",
  "admin.instanceName": "Name der Instanz",
  "admin.smtpHint": "Die Einstellungen gelten für die gesamte Instanz und werden verschlüsselt gespeichert. Änderungen ersetzen die bisherigen SMTP-Umgebungswerte. STARTTLS ist verpflichtend; TLS eignet sich üblicherweise für Port 465.",
  "admin.smtpEnabled": "E-Mail-Versand aktivieren",
  "admin.smtpHost": "SMTP-Server",
  "admin.smtpPort": "Port",
  "admin.smtpSecurity": "Verschlüsselung",
  "admin.smtpUser": "SMTP-Benutzername",
  "admin.smtpPassword": "SMTP-Passwort",
  "admin.smtpFrom": "Absenderadresse",
  "admin.passwordKeep": "Ein Passwort ist hinterlegt. Leer lassen, um es beizubehalten.",
  "admin.passwordNone": "Kein Passwort hinterlegt.",
  "admin.passwordClear": "Hinterlegtes Passwort entfernen",
  "admin.instanceAdmin": "Instanz-Administration",
  "admin.usersHint": "Instanz-Administratoren verwalten den Betrieb. Zugriff auf Projektinhalte bleibt an die Mitgliedschaften gebunden. Personen einladen, sperren und Arbeitsgruppenrollen ändern: in der jeweiligen Arbeitsgruppe unter Personen.",
  "admin.teamNew": "Team anlegen",
  "admin.teamEdit": "Team bearbeiten",
  "admin.teamCounts": "{people} Personen · {projects} Projekte",
  "admin.edit": "Bearbeiten",
  "admin.teamsHint": "Teams bündeln feste Personengruppen und können mehreren Projekten zugeordnet werden. Die Zuordnung organisiert die Zusammenarbeit und Gestaltung.",
  "admin.teamAccessHint": "Die Zuordnung erteilt keine zusätzlichen Zugriffsrechte. Projektmitgliedschaften und Rollen verwaltest du bewusst im jeweiligen Projekt.",
  "admin.showArchivedTeams": "Archivierte Teams anzeigen",
  "admin.teamArchive": "Team archivieren (Zuordnungen bleiben erhalten)",
  "admin.projectsHint": "Gestaltung der Projekte, in denen du Mitglied bist. Änderungen sind der Projektleitung vorbehalten. Das Board übernimmt die Gestaltung seines Projekts.",

  'app.name': 'Werft',
  'shell.navigation': 'Hauptnavigation',
  'shell.search': 'Suchen',
  'shell.searchProject': 'In diesem Projekt suchen …',
  'shell.searchAll': 'Suchen oder springen …',
  'shell.workspaces': 'Arbeitsgruppen',
  'shell.admin': 'Administration',
  'profile.menu': 'Profilmenü',
  'profile.edit': 'Profil bearbeiten',

  'common.save': 'Speichern',
  'filter.reset': 'Filter zurücksetzen ({n})',
  // Abnahme 0.58 F01: Rückweg nach einem Sprung in ein anderes Werkzeug
  'back.task': 'Zurück zur Aufgabe',
  'back.page': 'Zurück zur Notiz',
  'back.file': 'Zurück zur Datei',
  'back.topic': 'Zurück zum Thema',
  'back.overview': 'Zurück zur Übersicht',
  'back.tasks': 'Zurück zu den Aufgaben',
  'back.intake': 'Zurück zum Vorgang',
  'back.approvals': 'Zurück zu den Freigaben',
  'back.event': 'Zurück zum Termin',
  'back.decision': 'Zurück zur Entscheidung',
  'back.goal': 'Zurück zu den Zielen',
  'back.risk': 'Zurück zum Risiko',
  'back.budget': 'Zurück zum Budget',
  'back.contact': 'Zurück zum Kontakt',
  'back.shift': 'Zurück zum Einsatz',
  'back.folder': 'Zurück zum Ordner',
  'common.done': 'Fertig',
  'common.cancel': 'Abbrechen',
  'common.loading': 'Lädt …',
  'load.long': 'Wird geladen …',
  'load.failed': 'Das ließ sich gerade nicht laden.',
  'load.retry': 'Erneut versuchen',
  'load.stale': 'Nicht aktuell – letzte Aktualisierung fehlgeschlagen.',
  'load.updating': 'Wird aktualisiert …',
  'common.retry': 'Erneut versuchen',
  'common.email': 'E-Mail-Adresse',
  'common.password': 'Passwort',
  'linkAccess.paused': 'Der Zugang über den Projektlink zu „{project}“ ist vorübergehend deaktiviert.',
  'linkAccess.pausedHint': 'Die Projektleitung hat das Teilen per Link ausgeschaltet. Sobald es wieder eingeschaltet ist, geht es hier weiter. Was du bis dahin noch eingeben wolltest, wird nicht übernommen.',
  'linkAccess.locked': 'Externe Zugriffe auf „{project}“ sind vorübergehend gesperrt.',
  'linkAccess.lockedHint': 'Die Projektleitung hat externe Zugriffe gesperrt. Sobald die Sperre aufgehoben ist, geht es hier weiter.',
  'linkAccess.expired': 'Der Projektlink zu „{project}“ ist abgelaufen.',
  'linkAccess.expiredHint': 'Frag die Person, die dir den Link geschickt hat, nach einem neuen Link oder einer Verlängerung.',
  'linkAccess.retry': 'Erneut prüfen',
  'access.ended': 'Dein Zugang zu diesem Projekt ist beendet.',
  'join.invalid': 'Dieser Link ist ungültig, abgelaufen oder wurde zurückgezogen. Frag die Person, die ihn dir geschickt hat.',
  'linkGuest.session': 'Du bist über einen Projektlink angemeldet.',
  'linkGuest.badge': 'über Link',
  'linkGuest.title': 'Über einen Projektlink beigetreten – Name selbst angegeben',
  'common.name': 'Name',
  'common.back': 'Zurück',
  'common.offline': 'Keine Verbindung – Änderungen werden später abgeglichen',
  'common.reconnecting': 'Verbinde neu …',
  'common.undo': 'Rückgängig',
  'common.close': 'Schließen',
  'common.more': 'Weitere Aktionen',
  'common.saved': 'Gespeichert',
  'common.saving': 'Speichert …',


  'login.title': 'Anmelden',
  'login.withPassword': 'Mit Passwort',
  'login.withLink': 'Per Link',
  'login.submit': 'Anmelden',
  'login.sendLink': 'Anmeldelink senden',
  'login.linkSent': 'Wenn es ein Konto zu {email} gibt, ist der Link unterwegs. Er ist 15 Minuten gültig.',
  'login.passkey': 'Mit Passkey anmelden',
  'login.failed': 'E-Mail-Adresse oder Passwort stimmen nicht.',
  'login.noMail': 'Auf diesem Server ist kein E-Mail-Versand eingerichtet.',


  'lobby.title': 'Lobby',
  'lobby.workspaces': 'Deine Arbeitsgruppen',
  'lobby.noWorkspaces': 'Du bist noch in keiner Arbeitsgruppe. Lass dich einladen.',
  'lobby.projectsSoon': 'Projekte kommen mit Stufe 1. Hier erscheinen dann die Projektkarten dieser Arbeitsgruppe.',
  'lobby.settings': 'Einstellungen',
  'lobby.signOut': 'Abmelden',
  'lobby.admin': 'Verwaltung',

  'ws.revoked': 'Du hast keinen Zugriff mehr auf diese Arbeitsgruppe.',

  'admin.title': 'Instanzverwaltung',

  'project.new': 'Neues Projekt',
  'project.name': 'Projektname',
  'project.create': 'Anlegen',
  'project.empty': 'Noch keine Projekte. Leg das erste an – ein Name genügt.',
  'project.open': '{n} offen',
  'project.done': '{n} erledigt',
  'project.lobby': 'Lobby',
  'project.archived': 'Archiviert',
  'task.add': 'Aufgabe hinzufügen …',
  'task.addHint': 'Enter legt die Aufgabe an. Mehrere Zeilen einfügen legt mehrere an.',
  'task.empty': 'Noch keine Aufgaben. Schreib einfach los.',
  'task.toggle': '„{title}“ erledigt',
  'task.stateDone': '„{title}“ ist erledigt',
  'task.stateOpen': '„{title}“ ist offen',
  'task.more': 'Weitere laden',
  'task.showDone': 'Erledigte anzeigen ({n})',
  'task.hideDone': 'Erledigte ausblenden',
  'task.saving': 'Speichert …',
  'task.failed': 'Nicht gespeichert – erneut versuchen',
  'task.conflict': 'Jemand hat die Aufgabe inzwischen geändert. Der aktuelle Stand ist geladen.',
  'task.due': 'fällig {date}',
  'task.deleted': '„{title}“ gelöscht',
  'task.menu': 'Aktionen für „{title}“',
  'task.dragHandle': '„{title}“ verschieben',
  'task.dragHint': 'Ziehen zum Verschieben – oder Alt+Pfeil',
  'task.open': 'Details öffnen',
  'task.edit': 'Titel bearbeiten',
  'task.addSubtaskShort': 'Unteraufgabe hinzufügen …',
  'task.addChecklistShort': 'Checkliste hinzufügen …',
  'task.editLabel': 'Titel von „{title}“',
  'task.up': 'Nach oben',
  'task.down': 'Nach unten',
  'task.top': 'An den Anfang',
  'task.bottom': 'Ans Ende',
  'task.moveTo': 'In Liste „{list}“',
  'task.delete': 'Löschen',
  'task.row': '{title}{state}',
  'task.rowDone': ', erledigt',
  'task.keys': 'Pfeiltasten wählen · Umschalt+Pfeil mehrere auswählen · Leertaste erledigt · Enter Details · F2 umbenennen · f Fälligkeit · z Zuständig · p Priorität · l Labels · u Unteraufgaben · c Checkliste · h für heute · Alt+Pfeil verschieben · Entf löschen',
  'task.assignees': 'Zuständig',
  'task.notFound': 'Diese Aufgabe gibt es nicht mehr.',
  'project.people': 'Personen',
  'project.menu': 'Projekt-Aktionen',
  'view.table': 'Tabelle',
  'view.tableFiltered': 'Tabelle (gefiltert)',
  'view.filterActive': 'Filter aktiv',
  'view.tableFilterStays': 'Die Filter der Tabelle gelten nur in der Tabelle – hier siehst du wieder alle Aufgaben.',
  'view.calendar': 'Kalender',
  'palette.viewTable': 'Ansicht: Tabelle',
  'palette.viewCalendar': 'Ansicht: Kalender',
  'guests.readOnly': 'Als Gast kannst du hier nur ansehen.',
  'lobby.guestHint': 'Du bist Gast: Du siehst nur die Projekte, in die du eingeladen wurdest.',
  'project.gone': 'Dieses Projekt gibt es nicht oder du hast keinen Zugriff mehr.',

  'sync.pending': '{n} Änderungen werden gespeichert …',
  'sync.pendingOne': '1 Änderung wird gespeichert …',
  'sync.waiting': 'Offline – {n} Änderungen warten',
  'sync.waitingOne': 'Offline – 1 Änderung wartet',
  'derive.noSafeList': 'Im Bereich des Ausgangsinhalts gibt es noch keine Liste – die Aufgabe soll nicht für mehr Personen sichtbar werden.',
  'derive.createList': 'Liste dort anlegen',
  'derive.unsafeTarget': 'Diese Liste ist für mehr Personen sichtbar als der Ausgangsinhalt. Wähle eine Liste im selben Bereich.',
  'sync.failed': 'Nicht gespeichert: {message} – bitte noch einmal versuchen.',
  // Briefing „Arbeitsfreude“ AF11/AF12: Rückmeldung mit Bedeutung, Rückgängig als geprüfte Gegenoperation
  'feedback.offline': '– wird gespeichert, sobald du wieder online bist.',
  'feedback.moved': '„{title}“ verschoben nach {target}',
  'feedback.reordered': '„{title}“ verschoben',
  'feedback.milestone': 'Meilenstein erreicht: {title}',
  'undo.failed': 'Rückgängig ging nicht.',
  'undo.partly': '{n} Änderungen blieben stehen – sie wurden inzwischen von anderen geändert.',
  'undo.successorKept': '„{title}“ ist wieder offen. Die nächste Wiederholung war schon bearbeitet und bleibt bestehen.',
  'sync.createFailed': 'Nicht angelegt: {message}. Der Text steht wieder im Eingabefeld.',
  'sync.conflict': '„{title}“ wurde inzwischen geändert. Der aktuelle Stand wird angezeigt.',
  'sync.keepMine': 'Meine Fassung übernehmen',
  'sync.expired': 'zu lange offline',
  // 0.63: mehrere Aufgaben auf einmal (Rückmeldung im Startpaket; Dialog-Texte in deLazy.ts)
  'import.done': '{n} Aufgaben angelegt',
  'import.done1': 'Eine Aufgabe angelegt',
  'import.failed': 'Nicht importiert: {message}.',
  'import.reopen': 'Erneut prüfen',
  'import.undoPartial': '{n} Aufgaben archiviert – die übrigen hat inzwischen jemand anderes übernommen oder sie fehlen schon.',
  'import.menu': 'Aufgaben importieren …',
  'sync.expiredChange': 'Eine Änderung an „{title}“ war zu lange offline und wurde nicht gespeichert.',
  'sync.signOutPending': '{n} Änderungen sind noch nicht gespeichert. Beim Abmelden gehen sie verloren.',
  'sync.signOutAnyway': 'Trotzdem abmelden',
  'list.default': 'Aufgaben',
  'list.add': 'Liste hinzufügen',
  // Audit 0.36 F03: Gliedern
  'structure.menu': 'Gliedern …',
  'structure.which': 'Wie gliedern?',
  'structure.listTip': 'Eine Liste sammelt Aufgaben für sich (z. B. eine Phase). Nur leicht gliedern? Dann reicht ein Abschnitt.',
  'list.namePlaceholder': 'Name der neuen Liste',
  'list.menu': 'Aktionen für Liste „{name}“',
  'list.rename': 'Liste umbenennen',
  'list.nameLabel': 'Name von Liste „{name}“',
  'list.up': 'Liste nach oben',
  'list.down': 'Liste nach unten',
  'list.mergeInto': 'Zusammenführen mit „{name}“',
  'list.mergeTitle': 'Listen zusammenführen',
  'list.mergeText': 'Alle Aufgaben aus „{from}“ wandern ans Ende von „{to}“ – auch erledigte. IDs, Links und Zuständige bleiben. Die Liste „{from}“ verschwindet danach.',
  'list.mergeConfirm': 'Zusammenführen',
  'list.merged': '„{from}“ ist jetzt Teil von „{to}“.',
  'list.pending': 'wird angelegt …',
  'ext.menu': 'Externe Zugriffe …',
  'guestBar.view': 'Du bist Gast und kannst hier ansehen.',
  'guestBar.comment': 'Du bist Gast und kannst ansehen und kommentieren.',
  'guestBar.viaLink': 'Über einen Projektlink dabei als „{name}“ (selbst angegeben). Der Zugang endet, wenn der Link widerrufen wird oder abläuft.',
  'guestBar.edit': 'Du bist Gast und kannst ansehen, kommentieren und bearbeiten.',
  'guestBar.execute': 'Du bist Gast und kannst ansehen, kommentieren und Aufgaben erledigen.',
  'guestBar.until': 'Dein Zugang gilt bis {date}.',
  'guestStart.title': 'Willkommen im Projekt',
  'guestStart.next': 'Deine nächsten Schritte',
  'guestStart.important': 'Wichtig in diesem Projekt',
  'guestStart.tasks': 'Deine Aufgaben',
  'guestStart.approve': 'Abnahme: „{title}“',
  'ext.lockedBanner': 'Externe Zugriffe sind gesperrt – Gäste und Freigabelinks haben gerade keinen Zugang.',
  'display.button': 'Darstellung',
  'display.buttonPersonal': 'Darstellung (persönlich angepasst)',
  'view.label': 'Ansicht',
  'view.list': 'Liste',
  'view.board': 'Board',
  'board.cards': '{n} Aufgaben',
  'due.today': 'heute',
  'due.tomorrow': 'morgen',
  'due.yesterday': 'gestern',
  'due.label': 'Fällig {date}',
  'due.set': 'Fälligkeit …',
  'due.title': 'Fälligkeit',
  'people.set': 'Zuständig …',
  'people.title': 'Zuständig',
  'people.label': 'Zuständig: {names}',
  'comment.title': 'Kommentare',
  'comment.placeholder': 'Kommentar schreiben … (@ erwähnt jemanden)',
  'comment.send': 'Senden',
  'comment.sendHint': 'Strg+Enter sendet. @ erwähnt eine Person.',
  'comment.sendHintTouch': '@ erwähnt eine Person.',
  'comment.failed': 'Kommentar nicht gespeichert: {message}. Der Text steht wieder im Eingabefeld.',
  'comment.conflict': 'Der Kommentar wurde inzwischen geändert.',
  'comment.deleted': 'Kommentar gelöscht',
  'comment.edit': 'Bearbeiten',
  'comment.delete': 'Löschen',
  'comment.edited': 'bearbeitet',
  'comment.older': 'Ältere Kommentare laden',
  'comment.menu': 'Aktionen für Kommentar von {name}',
  'comment.react': 'Reaktion hinzufügen',
  'comment.reaction': '{emoji} von {names}',
  'comment.save': 'Speichern',
  'comment.mentions': 'Personen zum Erwähnen',
  'comment.unknown': 'Unbekannt',
  'comment.pending': 'wird gesendet …',
  'comment.editLabel': 'Kommentar bearbeiten',
  'attach.title': 'Anhänge',
  'attach.add': 'Datei anhängen',
  'attach.drop': 'Dateien hierher ziehen oder mit Strg+V einfügen',
  'attach.uploading': '„{name}“ wird hochgeladen … {percent} %',
  'attach.failed': '„{name}“: {message}',
  'attach.retry': 'Erneut versuchen',
  'attach.dismiss': 'Verwerfen',
  'attach.deleted': '„{name}“ entfernt',
  'attach.delete': 'Anhang „{name}“ entfernen',
  'attach.offline': 'Zum Hochladen braucht es eine Verbindung.',
  'attach.meta': '{size} · {name}',
  'follow.on': 'Folgen',
  'follow.off': 'Du folgst',
  'follow.label': 'Benachrichtigungen zu dieser Aufgabe: {n} Personen folgen',
  'activity.title': 'Verlauf',
  'activity.open': 'Verlauf',
  'activity.empty': 'Noch nichts passiert.',
  'activity.more': 'Ältere laden',
  'activity.created': '{actor} hat „{title}“ angelegt',
  'activity.completed': '{actor} hat „{title}“ erledigt',
  'activity.reopened': '{actor} hat „{title}“ wieder geöffnet',
  'activity.updated': '{actor} hat bei „{title}“ {fields} geändert',
  'activity.moved': '{actor} hat „{title}“ nach „{list}“ verschoben',
  'activity.archived': '{actor} hat „{title}“ gelöscht',
  'activity.restored': '{actor} hat „{title}“ wiederhergestellt',
  'activity.assigned': '{actor} hat bei „{title}“ die Zuständigkeit geändert{detail}',
  'activity.commented': '{actor} hat „{title}“ kommentiert',
  'activity.attached': '{actor} hat „{name}“ an „{title}“ angehängt',
  'activity.blueprint-installed': '{actor} hat das Projekt aus der Vorlage „{name}“ angelegt',
  'activity.module-added': '{actor} hat den Baustein „{name}“ ergänzt',
  'activity.tools-repaired': '{actor} hat fehlende Werkzeuge zugeschaltet ({name})',
  'activity.anchor-set': '{actor} hat den Stichtag gesetzt: {name}',
  'activity.role-set': '{actor} hat die Rolle besetzt: {name}',
  'activity.template-published': '{actor} hat eine Vorlagenfassung veröffentlicht ({name})',
  'activity.template-unpublished': '{actor} bietet die Vorlage „{name}“ nicht mehr an',
  'activity.project-link-created': '{actor} hat einen Projektlink angelegt ({name})',
  'activity.project-link-joined': '{name} ist über einen Projektlink beigetreten',
  'activity.project-link-revoked': '{actor} hat einen Projektlink widerrufen ({name})',
  'activity.project-links-paused': 'Projektlinks pausiert ({name})',
  'activity.webhook-removed': '{actor} hat einen Webhook entfernt ({name})',
  'activity.task-bound': '{actor} hat „{title}“ an einen Termin gebunden',
  'activity.task-unbound': '{actor} hat die Bindung von „{title}“ an den Termin gelöst',
  'transition.blocked': '„{title}“ bleibt, wo sie war: {message}',
  'save.unsaved': '{n} nicht gespeichert',
  'save.unsavedOpen': '{n} Änderung(en) nicht gespeichert ({what}) – anzeigen',
  'save.unsavedList': 'Nicht gespeicherte Änderungen',
  'save.openContent': 'Öffnen',
  'save.signOutUnsafe': 'Eine Eingabe ist auf diesem Gerät nicht gesichert und geht beim Abmelden verloren. Kopiere sie über „nicht gespeichert“ oder warte, bis sie übertragen ist.',
  'save.copy': '{what} kopieren',
  'save.copied': 'Kopiert',
  'save.discard': 'Entwurf verwerfen …',
  'save.discardSure': '{what} endgültig verwerfen',
  'save.localOnlyHint': 'Diese Eingabe liegt nur im geöffneten Fenster – der Gerätespeicher ist voll oder gesperrt. Schließe es nicht, bis sie übertragen ist, oder kopiere den Text.',
  'transition.hint': 'Hinweis zu „{title}“: {message}',
  'transition.hintMany': 'Hinweis für {n} Aufgaben: {message}',
  'transition.open': 'Aufgabe öffnen',
  'transition.blockedMany': '{n} Aufgaben bleiben, wo sie waren: {message}',
  'undo.partial': '{ok} von {n} geändert – die übrigen wurden abgewiesen (siehe Hinweis).',
  'activity.status-rule': '{actor} hat die Voraussetzungen eines Status geändert',
  'activity.status-override': '{actor} hat „{title}“ trotz Sperre weitergesetzt – Begründung: {name}',
  'activity.list-created': '{actor} hat die Liste „{name}“ angelegt',
  'activity.list-merged': '{actor} hat „{name}“ mit „{list}“ zusammengeführt',
  'activity.intakeChanged': '{actor} hat einen Vorgang im Eingang bearbeitet',
  'activity.generic': '{actor} hat etwas geändert',
  'activity.someone': 'Jemand',
  'field.title': 'den Titel',
  'field.description': 'die Beschreibung',
  'field.dueDate': 'die Fälligkeit',
  'field.startDate': 'den Start',
  'field.priority': 'die Priorität',
  'field.status': 'den Status',
  'inbox.title': 'Benachrichtigungen',
  'inbox.open': 'Benachrichtigungen, {n} ungelesen',
  'inbox.openNone': 'Benachrichtigungen',
  'time.now': 'gerade eben',
  'time.minutes': 'vor {n} Min.',
  'time.hours': 'vor {n} Std.',
  'time.yesterday': 'gestern, {time}',
  'task.comments': '{n} Kommentare',
  'task.attachments': '{n} Anhänge',
  'myday.title': 'Mein Tag',
  'myday.pin': 'Für heute vormerken',
  'myday.pinnedToast': '„{title}“ steht jetzt in Mein Tag.',
  'palette.title': 'Befehlspalette',
  'palette.scope': 'Wo suchen',
  'palette.scopeProject': 'In diesem Projekt',
  'palette.scopeProjectNamed': 'In „{name}“',
  'palette.scopeAll': 'Überall',
  'palette.placeholder': 'Suchen oder springen …',
  'palette.open': 'Suchen (Strg+K)',
  'palette.empty': 'Nichts gefunden.',
  'palette.here': 'Hier',
  'palette.go': 'Gehe zu',
  'palette.projects': 'Projekte',
  'palette.tasks': 'Aufgaben',
  'palette.newTask': 'Neue Aufgabe',
  'palette.viewBoard': 'Ansicht: Board',
  'palette.viewList': 'Ansicht: Liste',
  'keys.title': 'Tastaturkürzel',
  'keys.all': 'Alle Kürzel (?)',
  'keys.global': 'Überall',
  'keys.list': 'Liste',
  'keys.board': 'Board',
  'keys.myday': 'Mein Tag (zusätzlich)',
  'keys.comment': 'Kommentare',
  'keys.palette': 'Befehlspalette: springen, suchen, Aktionen',
  'keys.help': 'Diese Übersicht',
  'keys.undo': 'Letzte Änderung zurücknehmen, solange der Hinweis steht',
  'keys.move': 'Zeile wählen',
  'keys.done': 'Erledigt / wieder offen',
  'keys.open': 'Details öffnen',
  'keys.rename': 'Titel bearbeiten',
  'keys.subtasks': 'Unteraufgaben ansehen, abhaken, ergänzen',
  'keys.checklist': 'Checkliste ansehen, abhaken, ergänzen',
  'keys.due': 'Fälligkeit setzen',
  'keys.people': 'Zuständige wählen',
  'keys.reorder': 'Verschieben',
  'keys.column': 'In die Spalte links/rechts',
  'keys.delete': 'Löschen (mit Rückgängig)',
  'keys.new': 'Zum Eingabefeld',
  'keys.pin': 'Für heute vormerken / entfernen',
  'keys.send': 'Kommentar senden',
  'keys.mention': 'Person erwähnen',

  // Paket P8: Aufgaben vertiefen
  'picker.subtasks': 'Unteraufgaben',
  'picker.checklist': 'Checkliste',
  'picker.attachments': 'Anhänge',
  'picker.blockers': 'Wartet auf',
  'picker.repeat': 'Wiederholung',
  'picker.milestone': 'Meilenstein',
  'picker.pin': 'Angeheftet',
  'picker.due': 'Fälligkeit',
  'picker.people': 'Zuständig',
  'picker.priority': 'Priorität',
  'picker.labels': 'Labels',
  'priority.title': 'Priorität',
  'priority.none': 'Keine',
  'priority.1': 'Dringend',
  'priority.2': 'Hoch',
  'priority.3': 'Mittel',
  'priority.4': 'Niedrig',
  'priority.label': 'Priorität: {name}',
  'priority.set': 'Priorität …',
  'priority.clear': 'Priorität entfernen',
  'color.red': 'Rot',
  'color.custom': 'Eigene Farbe',
  'color.customNamed': 'Eigene Farbe {hex}',
  'color.pick': 'Farbe wählen',
  'color.hex': 'HEX-Wert',
  'color.invalid': 'Bitte sechs Stellen 0–9 oder A–F angeben, z. B. #146B62.',
  'color.preview': 'Vorschau',
  'color.apply': 'Übernehmen',
  'color.change': 'Farbe ändern',
  'color.orange': 'Orange',
  'color.amber': 'Gelb',
  'color.green': 'Grün',
  'color.teal': 'Türkis',
  'color.blue': 'Blau',
  'color.violet': 'Violett',
  'color.pink': 'Rosa',
  'color.gray': 'Grau',
  'labels.title': 'Labels',
  'labels.set': 'Labels …',
  'labels.on': 'Labels: {names}',
  'labels.colorOf': 'Farbe von „{name}“',
  'subtasks.progress': '{done} von {n} Unteraufgaben erledigt',
  'checklist.progress': '{done} von {n} Punkten abgehakt',
  'checklist.promote': 'Zur Unteraufgabe machen',
  'checklist.promoted': '„{text}“ ist jetzt eine Unteraufgabe.',
  'checklist.remove': 'Punkt löschen',
  'checklist.conflict': 'Der Punkt wurde gleichzeitig geändert: „{text}“.',
  'section.add': 'Abschnitt hinzufügen',
  'section.namePlaceholder': 'Name des Abschnitts',
  'section.nameLabel': 'Abschnitt „{name}“ umbenennen',
  'section.menu': 'Aktionen für Abschnitt „{name}“',
  'section.rename': 'Umbenennen',
  'section.up': 'Abschnitt nach oben',
  'section.down': 'Abschnitt nach unten',
  'section.dissolve': 'Abschnitt auflösen',
  'section.dissolved': 'Abschnitt „{name}“ aufgelöst – die Aufgaben bleiben in der Liste.',
  'section.addTask': 'Aufgabe in „{name}“ …',
  'section.moveTo': 'In Abschnitt „{name}“',
  'section.moveOut': 'Aus dem Abschnitt nehmen',
  'list.progress': '{done} von {n} erledigt',
  'select.start': 'Auswählen',
  'select.enter': 'Aufgaben auswählen',
  'select.row': 'Auswählen: {title}',
  'select.deleted': '{n} Aufgaben gelöscht.',
  'activity.section-created': '{actor} hat den Abschnitt „{name}“ angelegt',
  'activity.section-removed': '{actor} hat den Abschnitt „{name}“ aufgelöst',
  'field.labels': 'die Labels',

  // Paket P9: Projekt-Insel
  'tools.nav': 'Werkzeuge des Projekts',
  'look.menu': 'Darstellung …',
  'tasks.toolMenu': 'Aufgaben einrichten',
  'menu.moveToShort': 'Verschieben nach …',
  'task.moveTitle': '„{title}“ verschieben nach',
  'task.noSection': 'Ohne Abschnitt',
  'board.moveToPick': 'In Spalte verschieben …',
  'list.mergeMenu': 'Mit anderer Liste zusammenführen …',
  'list.mergePick': '„{name}“ zusammenführen mit',
  'tasks.viewTools': 'Auswählen, Darstellung und Einrichten der Aufgaben',
  'tools.overflow': 'Weitere ({n})',
  'tools.overflowLabel': 'Weitere Werkzeuge ({n})',
  'tools.manage': 'Werkzeuge …',
  'tools.title': 'Werkzeuge',
  'tools.intro': 'Ein Projekt startet schlicht mit seinen Aufgaben. Weitere Werkzeuge kannst du hier zuschalten und jederzeit wieder ausblenden – dabei geht nichts verloren.',
  'tools.tasks': 'Aufgaben',
  'tools.tasksAlways': 'Immer da',
  'tools.overview': 'Übersicht',
  'tools.overview.hint': 'Status, Fortschritt, nächste Termine, Angeheftetes, letzte Aktivität',
  'tools.add': 'Zuschalten',
  'tools.hide': 'Ausblenden',
  'tools.hidden': '„{name}“ ausgeblendet – Inhalte bleiben erhalten.',
  'tools.home': 'Startseite des Projekts',
  'tools.homeHint': 'Gilt für alle im Projekt: Hier landet man aus der Lobby und der Befehlspalette.',
  'settings.menu': 'Projekt …',
  'pin.on': 'An Übersicht anheften',
  'pin.off': 'Von der Übersicht lösen',
  'pin.done': '„{title}“ ist auf der Übersicht angeheftet.',
  'pin.undone': '„{title}“ ist nicht mehr angeheftet.',
  'pin.toOverview': 'Zur Übersicht',
  'recent.title': 'Weiterarbeiten',
  'recent.untitled': 'Ohne Titel',
  'recent.kind.task': 'Aufgabe',
  'recent.kind.page': 'Notiz',
  'recent.kind.file': 'Datei',
  'recent.kind.topic': 'Thema',
  'help.button': 'Was kann ich hier machen?',
  'help.new': 'Neu hier – kurz zeigen, was diese Ansicht kann',
  'task.completeFollowUp': 'Abschließen und nächsten Schritt …',
  'pin.pinned': 'Auf der Übersicht angeheftet',
  'health.title': 'Projektstatus',
  'health.on_track': 'Im Plan',
  'health.at_risk': 'Gefährdet',
  'health.critical': 'Kritisch',
  'health.set': 'Projektstatus setzen',
  'health.change': 'Ändern',
  'health.clear': 'Status entfernen',
  'health.note': 'Notiz zum Status',
  'health.notePlaceholder': 'Kurz: warum? (optional)',
  'health.by': '{name} · {when}',
  'activity.health': '{actor} hat den Projektstatus auf „{name}“ gesetzt',
  'activity.phase': '{actor} hat die Phase auf „{name}“ gesetzt',
  'activity.event-created': '{actor} hat den Termin „{title}“ angelegt',
  'project.edition': 'Ausgabe {n}',
  'project.editionTitle': 'Serie: {list}',
  'activity.baseline-created': '{actor} hat den Basisplan „{name}“ festgehalten',
  'report.menu': 'Statusbericht …',
  'hooks.menu': 'Webhooks …',
  'activity.decision-requested': '{actor} hat um eine Entscheidung gebeten: „{name}“',
  'activity.decision-updated': '{actor} hat die Anfrage „{name}“ geändert',
  'activity.decision-recorded': '{actor} hat entschieden: „{name}“',
  'activity.decision-superseded': '{actor} hat neu entschieden: „{name}“',
  'activity.decision-withdrawn': '{actor} hat die Anfrage „{name}“ zurückgezogen',
  'activity.decision-drafted': '{actor} hat eine Anfrage entworfen',
  'activity.event-updated': '{actor} hat den Termin „{title}“ bearbeitet',
  'activity.event-moved': '{actor} hat den Termin „{title}“ verschoben',
  'activity.event-cancelled': '{actor} hat den Termin „{title}“ abgesagt',
  'activity.event-restored': '{actor} hat die Absage von „{title}“ zurückgenommen',
  'activity.run-started': '{actor} hat ein Freigabeverfahren für „{name}“ gestartet',
  'activity.run-step': '{actor}: „{name}“ ist in der nächsten Freigabestufe',
  'activity.run-approved': '„{name}“ ist durch alle Freigabestufen abgenommen',
  'activity.run-stopped': 'Freigabeverfahren für „{name}“ gestoppt – Änderungen erbeten',
  'activity.run-withdrawn': '{actor} hat das Freigabeverfahren für „{name}“ zurückgezogen',
  'activity.approval-substituted': '{actor} hat für „{name}“ eine Vertretung bestimmt',
  'activity.tool-on': '{actor} hat das Werkzeug „{name}“ zugeschaltet',
  'activity.tool-off': '{actor} hat das Werkzeug „{name}“ ausgeblendet (Inhalte bleiben)',
  'activity.peopleAdded': '{actor} hat ins Projekt geholt: {detail}',
  'activity.peopleAddedTeam': '{actor} hat aus dem Team „{name}“ ins Projekt geholt: {detail}',
  // Audit 0.36 F02: Team ins Projekt holen
  'activity.pinned': '{actor} hat „{title}“ auf der Übersicht angeheftet',
  'activity.unpinned': '{actor} hat „{title}“ von der Übersicht gelöst',
  'presence.here': 'Gerade im Projekt: {names}',
  'presence.viewing': '{names} hat die Aufgabe gerade offen',
  'presence.alsoOpen': '{names} hat diese Aufgabe auch gerade offen.',

  // Paket P10: Betrieb
  'activity.emergency': '{actor} ist per Notfallzugriff beigetreten',
  'offline.reading': 'Offline – du siehst den zuletzt geladenen Stand. Änderungen werden gesendet, sobald die Verbindung zurück ist.',
  'app.update': 'Eine neue Version von Werft ist da.',
  'app.reload': 'Neu laden',

  // Paket P11: Dateien
  'tools.files': 'Dateien',
  'tools.files.hint': 'Projektablage mit Ordnern, Vorschau, Fassungen und Papierkorb',
  'palette.files': 'Dateien',
  'tools.docs': 'Notizen',
  'tools.docs.hint': 'Gemeinsam geschriebene Seiten: Notizen, Protokolle, Konzepte, Wiki – mit Versionen und Kommentaren',
  'palette.pages': 'Seiten',
  'docs.untitled': 'Ohne Titel',
  'docs.new': 'Neue Seite',
  'docs.trashed': '„{title}“ liegt im Papierkorb.',
  'docs.trashedWithSub': '„{title}“ und {n} Unterseite(n) liegen im Papierkorb.',
  'docs.imageFailed': 'Das Bild konnte nicht hochgeladen werden.',
  'docs.versionSaved': 'Stand gesichert.',
  'docs.versionQueued': 'Stand wird gesichert',
  'docs.versionRestored': 'Version {n} wiederhergestellt.',
  'tools.talk': 'Gespräche',
  'tools.talk.hint': 'Themen mit Antworten und ein Projektchat – mit Erwähnungen, Reaktionen und „als Aufgabe“',
  'tools.intake': 'Eingang',
  'tools.intake.hint': 'Anfragen aus Formularen, Mail und Telefon an einem Ort prüfen – Aufgaben daraus anlegen oder zuordnen. Gäste sehen ihn nie.',
  'tools.approvals': 'Freigaben',
  'tools.approvals.hint': 'Alle Abnahmen und festgehaltenen Entscheidungen des Projekts an einem Ort – was auf dich wartet, was offen ist, was entschieden wurde.',
  'tools.events': 'Termine',
  'tools.people': 'Personen',
  'tools.budget': 'Budget',
  'tools.resources': 'Einsätze',
  'tools.goals': 'Ziele & Risiken',
  'tools.time': 'Zeit',
  'tools.time.hint': 'Zeiten an Aufgaben oder im Projekt erfassen (Timer oder Dauer), einreichen und als Nachweis freigeben. Jede Person sieht nur ihre Zeiten, die Leitung alle; Gäste nie.',
  'tools.goals.hint': 'Ziele mit Messgröße und Risiken mit Einschätzung – Aufgaben als Maßnahmen verknüpft. Sehen Leitung und Mitglieder, nie Gäste.',
  'activity.goal-created': '{actor} hat das Ziel „{title}“ angelegt',
  'activity.goal-measured': '{actor} hat einen Messwert zu „{title}“ erfasst',
  'activity.goal-state': '{actor} hat den Stand von „{title}“ gesetzt',
  'activity.risk-created': '{actor} hat das Risiko „{title}“ erfasst',
  'activity.risk-reviewed': '{actor} hat das Risiko „{title}“ geprüft',
  'tools.resources.hint': 'Schichten und Einsätze planen, Räume, Material und Fahrzeuge buchen – ohne Doppelbelegung. Eingeteilte sehen nur ihre eigenen Einsätze.',
  'activity.resource-created': '{actor} hat die Ressource „{title}“ angelegt',
  'activity.booking-created': '{actor} hat „{title}“ gebucht',
  'activity.booking-cancelled': '{actor} hat eine Buchung von „{title}“ abgesagt',
  'activity.shift-created': '{actor} hat den Einsatz „{title}“ angelegt',
  'activity.shift-assigned': '{actor} hat {name} für „{title}“ eingeteilt',
  'activity.shift-confirmed': '{actor} hat den Einsatz „{title}“ zugesagt',
  'activity.shift-declined': '{actor} hat den Einsatz „{title}“ abgesagt',
  'tools.budget.hint': 'Geplante Kosten, Zusagen und Ist-Kosten mit Beleg – was ist noch verfügbar? Sehen nur Leitung und Mitglieder mit „Bearbeiten“, nie Gäste.',
  'activity.budget-line-created': '{actor} hat die Budgetposition „{title}“ angelegt',
  'activity.budget-line-updated': '{actor} hat „{title}“ im Budget geändert',
  'activity.budget-commitment': '{actor} hat die Kostenzusage „{title}“ erfasst',
  'activity.budget-commitment-cancelled': '{actor} hat die Kostenzusage „{title}“ storniert',
  'activity.budget-expense': '{actor} hat die Ausgabe „{title}“ erfasst',
  'activity.budget-expense-corrected': '{actor} hat die Ausgabe „{title}“ korrigiert',
  'tools.people.hint': 'Kontakte und Anmeldungen zu Terminen – mit Plätzen und Warteliste. Personendaten sehen nur die Leitung und freigeschaltete Mitglieder.',
  'tools.events.hint': 'Echte Termine mit Datum, Uhrzeit und Ort – Besprechungen, Workshops, Messetage. Vorbereitung als Aufgaben mit Herkunft; im Kalender-Abo enthalten.',
  'palette.topics': 'Themen',
  'talk.chat': 'Chat',
  'talk.unread': '{n} ungelesen',
  'decision.saved': 'Entscheidung zu „{title}“ festgehalten',
  'talk.resolvedShort': 'erledigt',
  'talk.resolved': '„{title}“ ist erledigt.',
  'talk.reopened': '„{title}“ ist wieder offen.',
  'talk.taskCreated': 'Aufgabe „{title}“ angelegt.',
  'activity.area-created': '{actor} hat den Bereich „{name}“ angelegt',
  'activity.area-dissolved': '{actor} hat den Bereich „{name}“ aufgelöst',
  'activity.area-team-only': '{actor} hat den Bereich „{name}“ nur fürs Team freigegeben',
  'activity.area-project-wide': '{actor} hat den Bereich „{name}“ für alle im Projekt geöffnet',
  'areas.nav': 'Bereiche des Projekts',
  'areas.title': 'Bereiche',
  'areas.all': 'Ganzes Projekt',
  'areas.mine': 'Meine Bereiche',
  'areas.memberMark': 'Du bist im Team',
  'areas.collapse': 'Bereichsleiste einklappen',
  'areas.expand': 'Bereichsleiste ausklappen',
  'areas.activeExpand': 'Aktiver Bereich: {name} – Bereichsleiste ausklappen',
  'areas.general': 'Allgemein',
  'areas.choose': 'Bereich wählen',
  'areas.add': 'Bereich anlegen',
  'areas.addFirst': 'Bereich anlegen …',
  'areas.firstHint': 'Mit Bereichen gliederst du ein großes Projekt, z. B. nach Teams. Alles Bisherige bleibt unter „Allgemein“; ein Bereich lässt sich jederzeit wieder auflösen.',
  'areas.addSub': 'Unterbereich anlegen',
  'areas.addSubTitle': 'Unterbereich in „{name}“',
  'areas.name': 'Name',
  'areas.namePlaceholder': 'z. B. Technik, Programm, Verpflegung',
  'areas.color': 'Farbe',
  'areas.colorN': 'Vorschlag {n}',
  'areas.create': 'Anlegen',
  'areas.menu': 'Aktionen für Bereich „{name}“',
  'areas.settings': 'Einstellungen und Team …',
  'areas.team': 'Bereichsteam',
  'areas.teamHint': 'Das Bereichsteam zeigt, wer hier zuständig ist – Personen aus dem Projekt, unabhängig von den Teams der Arbeitsgruppe. Die Bereichsleitung verwaltet Namen, Team und Unterbereiche. Sehen und mitarbeiten können alle im Projekt.',
  'areas.teamHintHidden': 'Nur fürs Team von „{name}“: Inhalte sehen nur dieses Team, die Teams darüber und die Projektleitung. Die Bereichsleitung verwaltet Namen, Team und Unterbereiche.',
  'areas.teamOnly': 'Nur fürs Team',
  'areas.visibility': 'Wer sieht den Bereich?',
  'areas.visibility.project': 'Alle im Projekt',
  'areas.visibility.project.hint': 'Listen, Dateien, Seiten und Themen sehen alle Projektmitglieder.',
  'areas.visibility.team': 'Nur das Team',
  'areas.visibility.team.hint': 'Nur das Team, die Teams übergeordneter Bereiche und die Projektleitung – auch in Suche, Verlauf und Benachrichtigungen. Unterbereiche gehören dazu.',
  'areas.dissolveTeamOnly': 'Achtung: Der Bereich ist nur fürs Team. Nach dem Auflösen sehen alle im Zielbereich seine Inhalte.',
  'areas.noTeam': 'Noch niemand im Team.',
  'areas.addMember': 'Person aus dem Projekt …',
  'areas.addMemberButton': 'Aufnehmen',
  'areas.removeMember': '{name} aus dem Team nehmen',
  'areas.roleOf': 'Rolle von {name}',
  'areas.role.lead': 'Bereichsleitung',
  'areas.role.member': 'Mitglied',
  'areas.join': 'Dem Team beitreten',
  'areas.leave': 'Team verlassen',
  'areas.move': 'Verschieben …',
  'areas.moveTitle': '„{name}“ verschieben',
  'areas.top': 'Oberste Ebene',
  'areas.dissolve': 'Bereich auflösen',
  'areas.dissolveTitle': '„{name}“ auflösen?',
  'areas.dissolveText': 'Listen, Ordner, Seiten, Themen und Unterbereiche wandern nach „{target}“. Es geht nichts verloren.',
  'areas.dissolved': 'Bereich „{name}“ aufgelöst – der Inhalt ist eine Ebene nach oben gewandert.',
  'areas.assign': 'In Bereich verschieben …',
  'areas.assignTitle': '„{name}“ in Bereich verschieben',
  'areas.noLists': 'In diesem Bereich gibt es noch keine Liste.',
  'areas.firstTask': 'In diesem Bereich gibt es noch keine Aufgaben. Leg einfach die erste an – die Liste dazu entsteht von selbst.',
  'areas.firstTaskPlaceholder': 'Erste Aufgabe anlegen …',
  'activity.file-added': '{actor} hat „{name}“ in die Ablage gelegt',
  'activity.file-version': '{actor} hat eine neue Fassung von „{name}“ abgelegt',
  'activity.file-commented': '{actor} hat eine Rückmeldung zu „{name}“ geschrieben',
  'activity.file-deleted': '{actor} hat „{name}“ in den Papierkorb gelegt',
  'activity.page-created': '{actor} hat die Seite „{name}“ angelegt',
  'activity.page-archived': '{actor} hat die Seite „{name}“ in den Papierkorb gelegt',
  'activity.page-restored': '{actor} hat die Seite „{name}“ zurückgeholt',
  'activity.page-version': '{actor} hat bei „{name}“ eine Version gesichert{detail}',
  'activity.topic-created': '{actor} hat das Thema „{name}“ eröffnet',
  'activity.topic-resolved': '{actor} hat das Thema „{name}“ als erledigt markiert',
  'activity.topic-reopened': '{actor} hat das Thema „{name}“ wieder geöffnet',
  // Paket P17: Vorlagen und „wie letztes Jahr“
  'dup.menu': 'Projekt duplizieren …',
  'template.badge': 'Vorlage',
  'template.catalog': 'Vorlage verwenden',
  'auto.menu': 'Abläufe und Regeln …',
  'plan.menu': 'Stichtage, Rollen und Bausteine …',
  'firstStep.label': 'Erster Schritt',
  'firstStep.dismiss': 'Hinweis ausblenden',
  'portfolio.timeline': 'Zeitachse',
  'archive.menu': 'Projekt archivieren …',
  'trash.menu': 'In den Papierkorb …',
  'lobby.search': 'Projekt suchen',
  'lobby.team': 'Team',
  'lobby.allTeams': 'Alle Teams',
  'lobby.onlyFav': 'Nur Favoriten',
  'lobby.moveFolder': '„{name}“ in Ordner verschieben',
  'lobby.fav': '„{name}“ als Favorit merken',
  'lobby.unfav': '„{name}“ nicht mehr als Favorit',
  'archive.banner': 'Archiviert – alle sehen das Projekt nur noch lesend.',
  'archive.restore': 'Wiederherstellen',
  'template.section': 'Vorlagen',
  'template.use': 'Verwenden',
  'template.useNamed': 'Neues Projekt aus „{name}“',
  'template.open': 'Vorlage öffnen',
  // Paket P18: eigene Felder
  'fields.menu': 'Felder …',
  'fields.title': 'Eigene Felder',
  'fields.intro': 'Felder ergänzen Aufgaben um das, was nur dieses Projekt braucht – etwa Kosten, Phase oder Ansprechperson. Sie erscheinen in den Details jeder Aufgabe und als Spalten in der Tabelle.',
  'fields.add': 'Feld hinzufügen',
  'fields.create': 'Hinzufügen',
  'fields.newName': 'Name des neuen Felds',
  'fields.namePlaceholder': 'z. B. Kosten',
  'fields.kind': 'Art',
  'fields.kind.text': 'Text',
  'fields.kind.number': 'Zahl',
  'fields.kind.date': 'Datum',
  'fields.kind.select': 'Auswahl',
  'fields.kind.person': 'Person',
  'fields.kind.checkbox': 'Ja/Nein',
  'fields.taken': 'Ein Feld mit diesem Namen gibt es schon.',
  'fields.max': 'Ein Projekt hat höchstens {n} eigene Felder.',
  'fields.nameOf': 'Name von „{name}“',
  'fields.up': '„{name}“ nach oben',
  'fields.down': '„{name}“ nach unten',
  'fields.deleteOf': '„{name}“ löschen',
  'fields.deleteTitle': 'Feld „{name}“ löschen?',
  'fields.deleteText': 'Die Werte verschwinden aus allen Aufgaben. Die Aufgaben selbst bleiben.',
  'fields.delete': 'Feld löschen',
  'fields.noOptions': 'Noch keine Auswahlwerte – unten eintippen und Enter drücken.',
  'fields.optionAdd': 'Auswahlwert hinzufügen …',
  'fields.optionAddTo': 'Auswahlwert zu „{name}“ hinzufügen',
  'fields.optionNameOf': 'Auswahlwert „{name}“',
  'fields.optionDeleteOf': 'Auswahlwert „{name}“ entfernen',
  'fields.empty': '–',
  'fields.yes': 'Ja',
  'fields.formerMember': 'Ehemaliges Mitglied',
  // Paket P19: Wiederholung und Meilensteine
  'repeat.every1.day': 'täglich',
  'repeat.every1.week': 'wöchentlich',
  'repeat.every1.month': 'monatlich',
  'repeat.every1.year': 'jährlich',
  'repeat.everyN.day': 'alle {n} Tage',
  'repeat.everyN.week': 'alle {n} Wochen',
  'repeat.everyN.month': 'alle {n} Monate',
  'repeat.everyN.year': 'alle {n} Jahre',
  'repeat.afterDone': 'ab Erledigen',
  'repeat.mark': 'Wiederholt sich {rule}',
  'repeat.next': 'Erledigt – die nächste ist fällig am {date}.',
  'milestone.mark': 'Meilenstein',
  'field.milestone': 'den Meilenstein',
  'field.accent': 'die Akzentfarbe',
  'field.cover': 'das Titelbild',
  'field.repeat': 'die Wiederholung',
  'activity.repeated': '{actor} hat die nächste Wiederholung von „{title}“ angelegt',
  // Paket P20: Freigabelinks
  'share.menu': 'Teilen …',
  'share.project': 'Projekt teilen',
  'share.projectShort': 'Teilen',
  'activity.shared': '{actor} hat „{name}“ per Link geteilt',
  'activity.unshared': '{actor} hat den Link zu „{name}“ zurückgezogen',
  // Paket P21: Gäste feiner
  'guests.chosenTasks': 'Freigegebene Aufgaben',
  'guests.removeTask': '„{title}“ entfernen',
  'guests.searchTask': 'Aufgabe suchen …',
  'guests.forTask': 'Für Gäste freigeben',
  'guests.viaProject': 'sieht das ganze Projekt',
  'guests.guest': 'Gast',
  'preview.banner': 'Vorschau: So sieht {name} dieses Projekt – nur lesen.',
  'preview.planned.view': 'Vorschau vor dem Einladen: So sähe ein Gast mit „Ansehen“ dieses Projekt – nur lesen.',
  'preview.planned.comment': 'Vorschau vor dem Einladen: So sähe ein Gast mit „Kommentieren“ dieses Projekt – nur lesen.',
  'preview.planned.execute': 'Vorschau vor dem Einladen: So sähe ein Gast mit „Ausführen“ dieses Projekt – nur lesen.',
  'preview.planned.edit': 'Vorschau vor dem Einladen: So sähe ein Gast mit „Bearbeiten“ dieses Projekt – nur lesen.',
  'preview.end': 'Vorschau beenden',
  'former.guest': '{name} (ehemals Gast)',
  'former.member': '{name} (ehemals im Projekt)',
  // Paket P22: Mitschreiben per Link
  'former.link': '{name} (über Link)',
  // Paket P23: Benachrichtigungen per E-Mail und Push, Später erinnern
  'notify.thisDevice': 'Dieses Gerät',
  // Paket P24: Portfolio
  'phase.planned': 'Geplant',
  'phase.active': 'Läuft',
  'phase.done': 'Abgeschlossen',
  'phase.title': 'Phase und Zeitraum',
  'phase.menu': 'Phase und Zeitraum …',
  'phase.hint': 'Für die Lobby: Projekte nach Phase gruppiert und auf der Zeitachse. Ohne Zeitraum gilt die Spanne der Aufgabentermine.',
  'phase.start': 'Beginn',
  'phase.end': 'Ende',
  'phase.clearDates': 'Zeitraum entfernen',
  'portfolio.view': 'Ansicht',
  'portfolio.cards': 'Karten',
  'portfolio.lead': 'Leitung',
  'portfolio.allLeads': 'Alle Leitungen',
  'portfolio.onlyLate': 'Nur im Verzug',
  'portfolio.late': 'Im Verzug',
  'portfolio.lateTitle': 'Im Verzug: {reasons}',
  'portfolio.reason.overdue': 'überfällige Aufgaben',
  'portfolio.reason.milestone': 'Meilenstein überschritten',
  'portfolio.reason.end': 'Ende überschritten',
  'portfolio.reason.health': 'Status kritisch',
  'portfolio.overdue': '{n} überfällig',
  'portfolio.next': 'Nächster Meilenstein: {title}, {when}',
  'portfolio.span': '{from} – {to}',
  'portfolio.noneMatch': 'Kein Projekt passt zu diesem Filter.',
  'portfolio.showDone': 'Abgeschlossene ({n})',
  // Paket P25: Aufgaben-Schlüssel und gespeicherte Ansichten
  'key.notFound': '{key} gibt es nicht – oder du siehst diese Aufgabe nicht.',
  'views.label': 'Ansichten',
  'views.all': 'Alle offenen',
  'views.mine': 'Meine Aufgaben',
  'views.saveAs': 'Als Ansicht speichern …',
  'views.update': 'Änderungen speichern',
  'views.name': 'Name der Ansicht',
  'views.shared': 'Für alle im Projekt',
  'views.sharedHint': 'Alle im Projekt sehen die Ansicht; ändern dürfen du und die Projektleitung.',
  'views.save': 'Speichern',
  'views.changed': 'geändert',
  'views.menu': 'Ansicht „{name}“ bearbeiten',
  'views.rename': 'Umbenennen',
  'views.share': 'Mit allen teilen',
  'views.unshare': 'Nur für mich',
  'views.delete': 'Löschen',
  'views.deleted': 'Ansicht „{name}“ gelöscht',
  'views.sharedBadge': 'geteilt',
  'views.palette': 'Ansicht: {name}',
  // Paket P26: Abhängigkeiten und Zeitachse
  'deps.waiting': 'wartet auf {n} offene Aufgabe(n)',
  'approval.failed': 'Die Abnahme konnte nicht gespeichert werden.',
  'approval.requested': 'Abnahme angefragt.',
  'approval.doneApproved': 'Abgenommen.',
  'approval.doneChanges': 'Änderungswunsch gesendet.',
  'activity.topic-decided': '{actor} hat zu „{name}“ entschieden',
  'activity.topic-result': '{actor} hat das Ergebnis von „{name}“ festgehalten',
  'activity.topic-result-cleared': '{actor} hat das Ergebnis von „{name}“ zurückgenommen',
  'result.saved': 'Ergebnis von „{title}“ festgehalten.',
  'result.cleared': 'Ergebnis von „{title}“ zurückgenommen.',
  'activity.approval-requested': '{actor} hat um Abnahme von „{name}“ gebeten',
  'activity.approval-approved': '{actor} hat „{name}“ abgenommen',
  'activity.approval-changes': '{actor} bittet bei „{name}“ um Änderungen',
  'activity.approval-withdrawn': '{actor} hat die Abnahme von „{name}“ zurückgezogen',
  'activity.external-locked': '{actor} hat externe Zugriffe gesperrt ({name})',
  'activity.external-unlocked': '{actor} hat externe Zugriffe entsperrt ({name})',
  'activity.guest-expired': 'Ein Gastzugang ist abgelaufen',
  'activity.guest-restored': '{actor} hat einen Gastzugang verlängert',
  'field.dependencies': 'Abhängigkeiten',
  'view.timeline': 'Zeitachse',
  'palette.viewTimeline': 'Ansicht: Zeitachse',
  'gantt.undated': '{n} offene Aufgabe(n) ohne Termin',
  'error.generic': 'Etwas ist schiefgelaufen.',
} as const;

export type MessageKey = keyof typeof de;
